// Single source of truth for how a top-level category is presented.
// Consumed by the /courses category cards and by the landing page's
// category wheel, so the two cannot drift apart.
export const CATEGORY_VISUALS = {
	biznis: {
		slug: "biznis",
		icon: "fa-briefcase-blank",
		color: "purple",
		rgbVar: "--business-rgb",
	},
	tehnologija: {
		slug: "tehnologija",
		icon: "fa-desktop",
		color: "blue",
		rgbVar: "--technology-rgb",
	},
	kreativa: {
		slug: "kreativa",
		icon: "fa-palette",
		color: "orange",
		rgbVar: "--creative-rgb",
	},
};
